import {
  Group,
  Heading,
  Paper,
  Paragraph,
  Skeleton,
  useToggle,
} from '@ingeniorforeningen/figurine-core';
import { stripText } from '../../helpers/textsHelpers';
import { Card } from './Card';
import { HistoryButton } from './HistoryButton';
import { UiCase } from '../../types';

type CardListProps = {
  loading: boolean;
  openCases: UiCase[] | null;
  closedCases: UiCase[] | null;
  noCasesText?: string;
  closedCasesText?: string;
  language: string;
  showHistoryText?: string;
  hideHistoryText?: string;
};

export const CardList = ({
  loading,
  openCases,
  closedCases,
  noCasesText,
  closedCasesText,
  language,
  showHistoryText,
  hideHistoryText,
}: CardListProps) => {
  const [hideHistory, toggle] = useToggle([false, true]);
  const closedCasesExists = closedCases && closedCases.length > 0;

  if (loading) {
    return <Skeleton width="100%" height="250px" />;
  }

  return (
    <Group mt="xl" m={0}>
      {openCases &&
        (openCases.length > 0 ? (
          openCases.map((cardCase, index) => (
            <Card cardCase={cardCase} key={`cardCaseOpen_${index}`} language={language} />
          ))
        ) : (
          <Paper>
            <Paragraph text={stripText(noCasesText)} />
          </Paper>
        ))}

      {hideHistory && closedCasesExists && (
        <>
          <Heading text={stripText(closedCasesText)} type="h3" mt="xl" mb="lg" />
          {closedCases.map((cardCase, index) => (
            <Card cardCase={cardCase} key={`cardCaseClosed_${index}`} language={language} />
          ))}
        </>
      )}

      {closedCasesExists && !loading && (
        <HistoryButton
          onClick={toggle}
          variant={hideHistory ? 'hideHistory' : 'showHistory'}
          showHistoryText={showHistoryText}
          hideHistoryText={hideHistoryText}
        />
      )}
    </Group>
  );
};
